module.exports = __webpack_public_path__ + "img/kulioner-not-buy.95ccfcf5.svg";